export enum BuildStateType {
    UNISAT = 'UNISAT',
    UNIHEXA = 'UNIHEXA'
}


export const STATE_API = process.env.REACT_APP_STATE_API || ''

export const FRACTAL_STATE_NAME = process.env.REACT_APP_FRACTAL_STATE_NAME || ''

export const FRACTAL_FEE_API = process.env.REACT_APP_FRACTAL_FEE_API || ''

export const BTC_FEE_API = process.env.REACT_APP_BTC_FEE_API || ''

export const BITCOIN_STATE_NAME = process.env.REACT_APP_BITCOIN_STATE_NAME || ''

export const UNIHEXA_STATE_NAME = process.env.REACT_APP_UNIHEXA_STATE_NAME || 'unihexa'

export const BUILD_STATE = process.env.REACT_APP_BUILD_STATE || BuildStateType.UNISAT



